import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import "../../../styles/Auth/customer.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import trayUpload from "@iconify/icons-mdi/tray-upload";
import { postData, uploadFile, getData, putData, deleteData } from "../../../webService/webservice.js";
const CustomerPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddCustomer = location.pathname === '/customers/add';
    const [searchQuery, setSearchQuery] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);
    const [IdPreviewUrl, setIdPreviewUrl] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [customerImage, setCustomerImage] = useState(null);
    const [IdProofImage, setIdProofImage] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [open, setOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [customerToDelete, setCustomerToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editCustomerId, setEditCustomerId] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [stateError, setStateError] = useState("");
    const [countryError, setCountryError] = useState("");
    const [cityError, setCityError] = useState("");
    const [errors, setErrors] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [activeTab, setActiveTab] = useState("profile");
    const [orders, setOrders] = useState([]);
    const [logs, setLogs] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        gender: '',
        customerImageObject: '',
        addressLine1: '',
        addressLine2: '',
        landmark: '',
        city: '',
        district: '',
        state: '',
        country: '',
        pincode: '',
    });


    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const validateEmail = (email) => {
        // Basic RFC 5322 official email regex simplified
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleEmailChange = (e) => {
        const email = e.target.value;
        setFormData((prev) => ({ ...prev, email }));

        if (!validateEmail(email)) {
            setEmailError("Please enter a valid email address");
        } else {
            setEmailError("");
        }
    };

    const validateCustomerForm = (formData) => {
        let errors = {};

        if (!formData.name?.trim()) {
            errors.name = "Customer Name is required";
        }

        // Mobile Number
        if (!formData.phoneNumber) {
            errors.phoneNumber = "Mobile Number is required";
        } else if (!/^\d{10}$/.test(formData.phoneNumber)) {
            errors.phoneNumber = "Mobile number must be exactly 10 digits";
        }

        if (!formData.gender?.trim()) {
            errors.gender = "Gender is required";
        }

        return errors;
    };

    const handleAddCustomer = async (e) => {
        e.preventDefault();
        const errors = validateCustomerForm(formData);

        if (Object.keys(errors).length > 0) {
            setErrors(errors);  // <-- Store errors to show under fields
            return;
        }
        setLoading(true);
        
        try {
            const sessionToken = sessionStorage.getItem("sessionToken");
            let uploadResult;
            if (customerImage) {
                // ✅ Upload customer & ID proof images
                uploadResult = await uploadFile(`files/upload/customer/`, customerImage);

                if (uploadResult?.status === 200) {
                    
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                }
            }
            const customerData = {
                name: formData.name,
                email: formData.email,
                gender: formData.gender,
                phoneNumber: formData.phoneNumber,
                customerImageObject: uploadResult?.data,
                dateOfBirth: formData.dateOfBirth,
                age: formData.age,
                addressLine1: formData.addressLine1,
                addressLine2: formData.addressLine2,
                landmark: formData.landmark,
                city: formData.city,
                state: formData.state,
                country: formData.country,
                pincode: formData.pincode
            };

            console.log("Sending customer data:", customerData);
            // ✅ Post to backend
            const response = await postData("customers", customerData, sessionToken);

            if (response?.status === 200) {
                toast.success(response.message || "Customer added successfully");

                // ✅ Reset form after success
                setFormData({
                    name: "",
                    email: "",
                    phoneNumber: "",
                    gender: "",
                    customerImageObject: "",
                    dateOfBirth: "",
                    age: "",
                    addressLine1: "",
                    addressLine2: "",
                    landmark: "",
                    city: "",
                    state: "",
                    country: "",
                    pincode: ""
                });
                setCustomerImage(null);
                setIdProofImage(null);
                setPreviewUrl(null);

                navigate("/customers");
                triggerRefresh();
            } else {
                toast.error(response?.message || "Failed to add customer");
            }
        } catch (error) {
            console.error("Add Customer Error:", error);
            toast.error(error.message || "Add Customer Failed");
        }
    };

    useEffect(() => {
        fetchCustomers(currentPage, limit, searchQuery, sessionToken);
    }, [currentPage, limit, refreshKey, searchQuery, sessionToken]);

    const fetchCustomers = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            search: searchQuery?.trim() || "",
        }
        try {
            setLoading(true);
            const response = await getData('customers/customers', params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const customerList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setCustomers(customerList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch categories");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateCustomer = async (e) => {
        e.preventDefault();
        const errors = validateCustomerForm(formData);

        if (Object.keys(errors).length > 0) {
            setErrors(errors);  // <-- Store errors to show under fields
            return;
        }
        setLoading(true);
        try {
            const sessionToken = sessionStorage.getItem("sessionToken");
            
            let updatedImageObject = formData.customerImageObject;
            let uploadResult;
            if (customerImage) {
                uploadResult = await uploadFile(`files/upload/customer`, customerImage, sessionToken);

                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    return;
                }
            }
            const updatedCustomerData = {
                name: formData.name,
                email: formData.email,
                gender: formData.gender,
                phoneNumber: formData.phoneNumber,
                customerImageObject: uploadResult?.data,
                dateOfBirth: formData.dateOfBirth,
                age: formData.age,
                addressLine1: formData.addressLine1,
                addressLine2: formData.addressLine2,
                landmark: formData.landmark,
                city: formData.city,
                state: formData.state,
                country: formData.country,
                pincode: formData.pincode
            };

            console.log("Updating Customer with data:", updatedCustomerData);

            const response = await putData(`customers/customer/${editCustomerId}`, updatedCustomerData, sessionToken);

            toast.success(response.message || 'Customer updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                name: "",
                email: "",
                phoneNumber: "",
                gender: "",
                customerImageObject: "",
                dateOfBirth: "",
                age: "",
                addressLine1: "",
                addressLine2: "",
                landmark: "",
                city: "",
                state: "",
                country: "",
                pincode: ""
            });
            setCustomerImage(null);
            setPreviewUrl(null);
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchCustomers(currentPage, limit);
            triggerRefresh();
        } catch (error) {
            toast.error("Error updating customer.");
        }
    }
    const handleDeleteCustomer = async (e) => {
        e.preventDefault();
        try {
            const sessionToken = sessionStorage.getItem('sessionToken');
            const response = await deleteData(`customers/customers/${customerToDelete}`, sessionToken);
            toast.success(response.message || "Customer deleted successfully");
            setCustomerToDelete(null);
            fetchCustomers(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Customer");
        }
    }
    const handleOpen = (customerId) => {
        setCustomerToDelete(customerId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCustomerToDelete(null);
    };

    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Name',
        'Phone Number',
        'Email',
        'Gender',
        'Action',
    ];

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const fetchOrders = async (customerId) => {
        try {
            const response = await getData(`orders/by-customer/${customerId}`, {}, sessionToken);
            setOrders(response?.data || []);
        } catch (err) {
            setOrders([]);
        }
    };

    const fetchLogs = async (customerId) => {
        try {
            const response = await getData(`activity/customer/${customerId}`, {}, sessionToken);
            setLogs(response?.data || []);
        } catch (err) {
            setLogs([]);
        }
    };

    const handleAlphabeticInput = (e, fieldName) => {
        const value = e.target.value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setFormData((prev) => ({ ...prev, [fieldName]: value }));
            if (fieldName === "city") setCityError("");
            if (fieldName === "country") setCountryError("");
            if (fieldName === "state") setStateError("");
        } else {
            if (fieldName === "city") setCityError("Only letters and spaces allowed");
            if (fieldName === "country") setCountryError("Only letters and spaces allowed");
            if (fieldName === "state") setStateError("Only letters and spaces allowed");
        }
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleChange = e => {
        const { name, value } = e.target;
        // For firstName and lastName: only alphabets, no spaces
        if ((name === 'firstName' || name === 'lastName')) {

            if (/[^a-zA-Z]/.test(value)) return;

            const capitalizedValue =
                value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

            setFormData((prev) => ({
                ...prev,
                [name]: capitalizedValue,
            }));
            return;
        }

        if (name === 'confirmPassword' || name === 'password') {
            const newPassword = name === 'password' ? value : formData.password;
            const newConfirm = name === 'confirmPassword' ? value : formData.confirmPassword;

            if (newPassword && newConfirm && newPassword !== newConfirm) {
                setPasswordMatchError('Passwords do not match');
            } else {
                setPasswordMatchError('');
            }
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    function calculateAge(dob) {
        if (!dob) return "";
        const today = new Date();
        const birthDate = new Date(dob);

        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    const indianStates = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Andaman and Nicobar Islands",
        "Chandigarh",
        "Dadra and Nagar Haveli and Daman & Diu",
        "Delhi",
        "Jammu & Kashmir",
        "Ladakh",
        "Lakshadweep",
        "Puducherry"
    ];

    return (
        <div className="customer-layout">
            <div className="customer-content">
                <main className="customer-main">
                    {isAddCustomer ? (
                        <div className="add-customer-form">
                            <h3>Add Customer</h3>
                            <form className="customer-form" onSubmit={handleAddCustomer}>
                                <div className="customer-form-row">
                                    <div className="customer-form-group-image">
                                        <div className="image-upload-wrapper">
                                            <div className="image-placeholder">
                                                <img
                                                    src={previewUrl || '/assets/mdi--user.svg'}
                                                    alt="Preview"
                                                    className="round-image"
                                                />
                                            </div>
                                        </div>
                                        <div className="upload-icon-container">
                                            <label htmlFor="customerImage" className="upload-icon-btn">
                                                Upload Image
                                                <Icon icon={trayUpload} width="24" height="24" />
                                                <input
                                                    type="file"
                                                    id="customerImage"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        setCustomerImage(file);
                                                        setPreviewUrl(URL.createObjectURL(file));
                                                    }}
                                                />

                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label htmlFor="name" className="input-label">
                                            Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter customer name"
                                            className={`customer-input ${errors.name ? "input-error" : ""}`}
                                            value={formData.name}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                            }
                                        />
                                        {errors.name && <p className="error-msg">{errors.name}</p>}
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="email" className="input-label">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            className="customer-input"
                                            placeholder="Enter Email"
                                            value={formData.email || ""}
                                            onChange={handleEmailChange}
                                        />
                                        {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="phoneNumber" className="input-label">Mobile Number<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            className={`customer-input ${errors.phoneNumber ? "input-error" : ""}`}
                                            placeholder="Enter Mobile Number"
                                            maxLength={10}
                                            title="Mobile Number must be exactly 10 digits"
                                            value={formData.phoneNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 10 characters
                                                if (/^\d{0,10}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                }
                                            }}
                                            onBlur={() => {
                                                if (formData.phoneNumber.length !== 10) {
                                                    alert("Mobile Number must be exactly 10 digits");
                                                }
                                            }}
                                        />
                                        {errors.phoneNumber && <p className="error-msg">{errors.phoneNumber}</p>}
                                    </div>
                                </div>
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label htmlFor="dateOfBirth" className="input-label">
                                            Date-Of-Birth
                                        </label>
                                        <input
                                            name="dateOfBirth"
                                            placeholder="enter Date Of Birth"
                                            type="date"
                                            className="customer-input"
                                            value={formData.dateOfBirth || ""}
                                            onChange={(e) => {
                                                const dob = e.target.value;
                                                const age = calculateAge(dob);

                                                setFormData({
                                                    ...formData,
                                                    dateOfBirth: dob,
                                                    age: age
                                                });
                                            }}
                                        />
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="age" className="input-label">
                                            Age
                                        </label>
                                        <input
                                            type="number"
                                            className="customer-input"
                                            value={formData.age || ""}
                                            readOnly
                                        />
                                    </div>
                                    <div className="customer-form-group">
                                        <label htmlFor="gender" className="input-label">
                                            Gender<span className="required">*</span>
                                        </label>
                                        <select
                                            id="gender"
                                            className={`customer-input ${errors.gender ? "input-error" : ""}`}
                                            placeholder="Select Gender"
                                            value={formData.gender}
                                            onChange={(e) => {
                                                const selectedgendertype = e.target.value;
                                                setFormData((prev) => ({ ...prev, gender: selectedgendertype }))
                                            }}
                                        >
                                            <option value='' >Select Gender</option>
                                            <option value='Male'>Male</option>
                                            <option value='Female'>Female</option>
                                            <option value='Other'>Other</option>
                                        </select>
                                        {errors.gender && <p className="error-msg">{errors.gender}</p>}
                                    </div>
                                </div>
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label className="input-label">Address Line 1</label>
                                        <input
                                            type="text"
                                            className={`customer-input ${errors.addressLine1 ? "input-error" : ""}`}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, addressLine1: e.target.value }))
                                            }
                                        />
                                    </div>

                                    <div className="customer-form-group">
                                        <label className="input-label">Address Line 2</label>
                                        <input
                                            type="text"
                                            className="customer-input"
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, addressLine2: e.target.value }))
                                            }
                                        />
                                    </div>

                                    <div className="customer-form-group">
                                        <label className="input-label">Landmark</label>
                                        <input
                                            type="text"
                                            className="customer-input"
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, landmark: e.target.value }))
                                            }
                                        />
                                    </div>
                                </div>

                                {/* ROW 5 - CITY, STATE, PINCODE */}
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label className="input-label">City</label>
                                        <input
                                            type="text"
                                            className={`customer-input ${errors.city ? "input-error" : ""}`}
                                            onChange={(e) => handleAlphabeticInput(e, "city")}
                                        />
                                    </div>

                                    <div className="customer-form-group">
                                        <label className="input-label">
                                            State
                                        </label>

                                        <select
                                            className={`customer-input ${errors.state ? "input-error" : ""}`}
                                            value={formData.state || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, state: e.target.value }))
                                            }
                                        >
                                            <option value="">Select State</option>
                                            {indianStates.map((state) => (
                                                <option key={state} value={state}>
                                                    {state}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* ROW 6 */}
                                <div className="customer-form-row">
                                    <div className="customer-form-group">
                                        <label className="input-label">Country</label>
                                        <input
                                            type="text"
                                            className={`customer-input ${errors.country ? "input-error" : ""}`}
                                            onChange={(e) => handleAlphabeticInput(e, "country")}
                                        />
                                    </div>

                                    <div className="customer-form-group">
                                        <label className="input-label">Pincode</label>
                                        <input
                                            type="text"
                                            className={`customer-input ${errors.pincode ? "input-error" : ""}`}
                                        />
                                    </div>
                                </div>
                                <div className="customer-buttons">
                                    <button className="add-customer-button" type="submit" disabled={emailError !== ""} onClick={isAddCustomer ? handleAddCustomer : handleUpdateCustomer}>
                                        {isEditMode ? "Update customer" : "Add customer"}
                                    </button>
                                    <button className="cancel-customer-button" onClick={() => navigate('/customers')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div >
                    ) : (
                        <>
                            <div className="customer-widgets">
                                <div className="customer-widgets-header">
                                    <h3>Customers</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="customer-search-input"
                                        name="search"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="customer-actions">

                                    <button className="add-btn-customer" onClick={() => navigate('/customers/add')}>
                                        + Add New
                                    </button>

                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-customer-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-customer-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {customers.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No Customers found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            customers.map((customer, index) => (
                                                <TableRow key={customer._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{customer.name || customer.firstName}</Typography></TableCell>                                                    
                                                    <TableCell><Typography sx={commonCellStyle}>{customer.phoneNumber}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{customer.email}</Typography></TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{customer.gender}</Typography></TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={plusIcon} width={20} height={20} style={{ cursor: 'pointer' }} onClick={() => {
                                                                setSelectedCustomer(customer);
                                                                setShowPopup(true);
                                                                setActiveTab("profile"); // reset tab
                                                                fetchOrders(customer._id);
                                                                fetchLogs(customer._id);
                                                            }} />
                                                            {/* <Icon icon={plusIcon} width={20} height={20} /> */}
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                setFormData({
                                                                    name: customer.name || '',
                                                                    email: customer.email || '',
                                                                    gender: customer.gender || '',
                                                                    phoneNumber: customer.phoneNumber || '',
                                                                    customerImageObject: customer.customerImageObject || '',
                                                                    dateOfBirth: customer.dateOfBirth || '',
                                                                    age: customer.age || '',
                                                                    addressLine1: customer.billingAddress.doorNo || '',
                                                                    addressLine2: customer.billingAddress.streetName || '',
                                                                    landmark: customer.billingAddress.landmark || '',
                                                                    city: customer.billingAddress.city || '',
                                                                    state: customer.billingAddress.state || '',
                                                                    country: customer.billingAddress.country || '',
                                                                    pincode: customer.billingAddress.pincode || ''
                                                                });
                                                                setPreviewUrl(
                                                                    customer?.customerImageObject?.uri
                                                                        ? `${process.env.REACT_APP_API_URL}${customer.customerImageObject.uri}`
                                                                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                );
                                                                setIdPreviewUrl(customer.idProofDocument || '');
                                                                setCustomerImage(null);
                                                                setEditCustomerId(customer._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: 'pointer' }}
                                                                onClick={() => handleOpen(customer._id)}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="product-bottom">
                                <div className="product-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="product-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="product-section spacer"></div>
                                <div className="product-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setFormData({
                                                    name: "",
                                                    email: "",
                                                    phoneNumber: "",
                                                    gender: "",
                                                    customerImageObject: "",
                                                    dateOfBirth: "",
                                                    age: "",
                                                    addressLine1: "",
                                                    addressLine2: "",
                                                    landmark: "",
                                                    city: "",
                                                    state: "",
                                                    country: "",
                                                    pincode: ""
                                                });
                                                setPreviewUrl(null);
                                            }}
                                        />
                                        <div className="popup-form-Customer">
                                            <h2 className="popup-title">
                                                {isEditMode ? "Edit Customer" : "Add Customer"}
                                            </h2>
                                            <form className="popup-form-body" onSubmit={handleUpdateCustomer}>
                                                <div className="form-group-row">
                                                    <div className="customer-form-group-image">
                                                        <div className="image-upload-wrapper">
                                                            <div className="image-placeholder">
                                                                <img
                                                                    src={previewUrl || '/assets/mdi--user.svg'}
                                                                    alt="Preview"
                                                                    className="round-image"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="upload-icon-container">
                                                            <label htmlFor="customerImage" className="upload-icon-btn">
                                                                Upload Image
                                                                <Icon icon={trayUpload} width="24" height="24" />
                                                                <input
                                                                    type="file"
                                                                    id="customerImage"
                                                                    accept="image/*"
                                                                    style={{ display: 'none' }}
                                                                    onChange={(e) => {
                                                                        const file = e.target.files[0];
                                                                        setCustomerImage(file);
                                                                        setPreviewUrl(URL.createObjectURL(file));
                                                                    }}
                                                                />
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="name" className="input-label">
                                                            Name<span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            placeholder="Enter customer name"
                                                            className={`customer-input ${errors.name ? "input-error" : ""}`}
                                                            value={formData.name}
                                                            onChange={e =>
                                                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                                            }
                                                        />
                                                        {errors.name && <p className="error-msg">{errors.name}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="phoneNumber" className="input-label">Mobile Number<span className="required">*</span></label>
                                                        <input
                                                            type="text"
                                                            className={`customer-input ${errors.phoneNumber ? "input-error" : ""}`}
                                                            placeholder="Enter Mobile Number"
                                                            maxLength={12}
                                                            title="Mobile Number must be exactly 12 digits"
                                                            value={formData.phoneNumber}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Allow only digits and max 12 characters
                                                                if (/^\d{0,10}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                                                }
                                                            }}
                                                        />
                                                        {errors.phoneNumber && <p className="error-msg">{errors.phoneNumber}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="email" className="input-label">
                                                            Email
                                                        </label>
                                                        <input
                                                            type="email"
                                                            className="customer-input"
                                                            placeholder="Enter Email"
                                                            value={formData.email || ""}
                                                            onChange={handleEmailChange}
                                                        />
                                                        {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="gender" className="input-label">
                                                            Gender<span className="required">*</span>
                                                        </label>
                                                        <select
                                                            id="gender"
                                                            className={`customer-input ${errors.name ? "input-error" : ""}`}
                                                            placeholder="Select Gender"
                                                            value={formData.gender}
                                                            onChange={(e) => {
                                                                const selectedgendertype = e.target.value;
                                                                setFormData((prev) => ({ ...prev, gender: selectedgendertype }))
                                                            }}
                                                        >
                                                            <option value='' >Select Gender</option>
                                                            <option value='Male'>Male</option>
                                                            <option value='Female'>Female</option>
                                                            <option value='Other'>Other</option>
                                                        </select>
                                                        {errors.gender && <p className="error-msg">{errors.gender}</p>}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="dateOfBirth" className="input-label">
                                                            Date Of Birth
                                                        </label>
                                                        <input
                                                            name="dateOfBirth"
                                                            placeholder="enter Date Of Birth"
                                                            type="date"
                                                            className="department-input"
                                                            value={formData.dateOfBirth ? formData.dateOfBirth.split("T")[0] : ""}
                                                            onChange={(e) => {
                                                                const dateOfBirth = e.target.value;
                                                                const age = calculateAge(dateOfBirth);

                                                                setFormData({
                                                                    ...formData,
                                                                    dateOfBirth: dateOfBirth,
                                                                    age: age
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="age" className="input-label">
                                                            Age
                                                        </label>
                                                        <input
                                                            type="number"
                                                            className="department-input"
                                                            value={formData.age || ""}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="customer-form-group">
                                                        <label className="input-label">Address Line 1</label>
                                                        <input
                                                            type="text"
                                                            className={`customer-input ${errors.addressLine1 ? "input-error" : ""}`}
                                                            value={formData.addressLine1 || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, addressLine1: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="customer-form-group">
                                                        <label className="input-label">Address Line 2</label>
                                                        <input
                                                            type="text"
                                                            className="customer-input"
                                                            value={formData.addressLine2 || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, addressLine2: e.target.value }))
                                                            }
                                                        />
                                                    </div>

                                                    <div className="customer-form-group">
                                                        <label className="input-label">Landmark</label>
                                                        <input
                                                            type="text"
                                                            className="customer-input"
                                                            value={formData.landmark || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, landmark: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                {/* ROW 5 - CITY, STATE, PINCODE */}
                                                <div className="form-group-row">
                                                    <div className="customer-form-group">
                                                        <label className="input-label">City</label>
                                                        <input
                                                            type="text"
                                                            className={`customer-input ${errors.city ? "input-error" : ""}`}
                                                            value={formData.city || ""}
                                                            onChange={(e) => handleAlphabeticInput(e, "city")}
                                                        />
                                                    </div>

                                                    <div className="customer-form-group">
                                                        <label className="input-label">
                                                            State
                                                        </label>

                                                        <select
                                                            className={`customer-input ${errors.state ? "input-error" : ""}`}
                                                            value={formData.state || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, state: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select State</option>
                                                            {indianStates.map((state) => (
                                                                <option key={state} value={state}>
                                                                    {state}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* ROW 6 */}
                                                <div className="form-group-row">
                                                    <div className="customer-form-group">
                                                        <label className="input-label">Country</label>
                                                        <input
                                                            type="text"
                                                            className={`customer-input ${errors.country ? "input-error" : ""}`}
                                                            value={formData.country || ""}
                                                            onChange={(e) => handleAlphabeticInput(e, "country")}
                                                        />
                                                    </div>

                                                    <div className="customer-form-group">
                                                        <label className="input-label">Pincode</label>
                                                        <input
                                                            type="text"
                                                            className={`customer-input ${errors.pincode ? "input-error" : ""}`}
                                                            value={formData.pincode || ""}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, pincode: e.target.value }))
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                
                                                <div className="form-actions">
                                                    <button type="submit" className="btn-primary">
                                                        {isEditMode ? "Update Product" : "Add Product"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn-secondary"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {limit > 5 && customers.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Customers
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Customer?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} onClick={handleDeleteCustomer}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}
                    {showPopup && selectedCustomer && (
                    <div className="popup-overlay">
                        <div className="popup-box popup-scrollable">

                            <button className="popup-close-btn" onClick={() => setShowPopup(false)}>
                                ✖
                            </button>

                            <h2 className="popup-title">Customer Details</h2>

                            {/* ---------------- Tabs ---------------- */}
                            <div className="popup-tabs">
                                <button 
                                    className={activeTab === "profile" ? "tab active" : "tab"}
                                    onClick={() => setActiveTab("profile")}
                                >
                                    Profile
                                </button>

                                <button 
                                    className={activeTab === "orders" ? "tab active" : "tab"}
                                    onClick={() => setActiveTab("orders")}
                                >
                                    Orders
                                </button>

                                <button 
                                    className={activeTab === "logs" ? "tab active" : "tab"}
                                    onClick={() => setActiveTab("logs")}
                                >
                                    Activity Logs
                                </button>
                            </div>

                            <div className="popup-tab-content">

                                {/* ----------- TAB 1: PROFILE ----------- */}
                                {activeTab === "profile" && (
                                    <div className="popup-section">
                                        <img
                                            src={
                                                selectedCustomer.customerImageObject?.uri
                                                    ? `${process.env.REACT_APP_API_URL}${selectedCustomer.customerImageObject.uri}`
                                                    : "/assets/mdi--user.svg"
                                            }
                                            className="popup-avatar-big"
                                        />

                                        <div className="popup-info-grid">
                                            <p><strong>Name:</strong> {selectedCustomer.name}</p>
                                            <p><strong>Email:</strong> {selectedCustomer.email}</p>
                                            <p><strong>Phone:</strong> {selectedCustomer.phoneNumber || "-"}</p>
                                            <p><strong>Gender:</strong> {selectedCustomer.gender}</p>
                                            <p><strong>City:</strong> {selectedCustomer.city}</p>
                                            <p><strong>State:</strong> {selectedCustomer.state}</p>
                                            <p><strong>Country:</strong> {selectedCustomer.country}</p>
                                            <p><strong>Pincode:</strong> {selectedCustomer.pincode}</p>
                                        </div>
                                    </div>
                                )}

                                {/* ----------- TAB 2: ORDERS ----------- */}
                                {activeTab === "orders" && (
                                    <div className="popup-section">
                                        {orders.length === 0 ? (
                                            <p>No Orders Found</p>
                                        ) : (
                                            <table className="popup-table">
                                                <thead>
                                                    <tr>
                                                        <th>Order No</th>
                                                        <th>Date</th>
                                                        <th>Status</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {orders.map(order => (
                                                        <tr key={order._id}>
                                                            <td>{order.orderNumber}</td>
                                                            <td>{order.createdAt?.split("T")[0]}</td>
                                                            <td>{order.appStatus}</td>
                                                            <td>₹{order.totalAmount}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                )}

                                {/* -------- TAB 3: ACTIVITY LOGS -------- */}
                                {activeTab === "logs" && (
                                    <div className="popup-section">
                                        {logs.length === 0 ? (
                                            <p>No Activity Logs</p>
                                        ) : (
                                            <ul className="logs-list">
                                                {logs.map(log => (
                                                    <li key={log._id}>
                                                        <span>{log.action}</span>
                                                        <small>{log.createdAt?.replace("T", " ").split(".")[0]}</small>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                )}
                </main >
            </div >

        </div >
    );
};


export default CustomerPage;